<template>
  <div class="word-list16">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div class="main">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            :style="{
              backgroundImage: 'url(' + item.image + ')'
            }"
          >
            <div class="con">
              <div class="top">
                <div class="name">{{ item.title }}</div>
                <div class="age">{{ item.subtitle }}</div>
              </div>
              <div class="bot">
                <div class="intro">
                  {{ item.tips }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          v-if="total > 8"
          @current-change="onCurrentChange"
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          :page-size="pageSize"
          :total="total"
          class="m-pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      params: {},
      dataInfo: {},
      pageSize: 8,
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
      const dataInfo = await this.getMenuInfo(this.params.menuId);
      this.dataInfo = dataInfo;
    },
    getAjax() {
      this.getList();
    }
  }
};
</script>
<style lang="less">
.word-list16 {
  .head {
    height: 280px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-top: 60px;
    padding-bottom: 120px;
    .main {
      display: flex;
      flex-wrap: wrap;
      .item {
        position: relative;
        margin-bottom: 20px;
        margin-right: 20px;
        width: 285px;
        height: 350px;
        box-sizing: border-box;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        .con {
          position: absolute;
          bottom: 0;
          padding: 20px;
          width: 285px;
          height: 100px;
          background: rgba(0, 0, 0, 0.6);
          box-sizing: border-box;
          .top {
            display: flex;
            align-items: center;
            .name {
              font-size: 20px;
              color: #fff;
            }
            .age {
              padding-left: 10px;
              font-size: 12px;
              color: #fff;
            }
          }

          .intro {
            padding-top: 10px;
            font-size: 12px;
            color: #fff;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .item:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>
